import {Button, Modal} from "react-bootstrap";
import React from "react";

function NassauAlert(props) {
  const {showAlert, title, message} = props;

  const handleClose = () => {
    if (props.handleClose) {
      props.handleClose();
    }
  }

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showAlert}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer style={{justifyContent: 'center', flexWrap: 'nowrap'}}>
        <Button variant="primary" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default NassauAlert;